import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './TopicHeader.module.scss';

const TopicHeader = ({
  header,
  searchVal,
  selectVal,
  selectData,
  onSearch,
  onSelect,
}) => {
  const [dropdown, setDropdown] = useState(false);
  const handleDropdown = useCallback(() => setDropdown(!dropdown), [dropdown]);
  const handleBlur = useCallback(() => setDropdown(false), []);
  const handleSelect = useCallback(
    ({ currentTarget: { value } }) => onSelect(value),
    [onSelect]
  );
  const handleSearch = useCallback(
    ({ currentTarget: { value } }) => onSearch(value),
    [onSearch]
  );
  return (
    <div className={styles.mainContainer}>
      <div className={styles.header}>{header}</div>
      <div className={styles.form}>
        <input
          type="text"
          placeholder="Search..."
          onChange={handleSearch}
          value={searchVal}
        />
        <div>
          <label htmlFor="dropdown">Sort By</label>
          <select
            id="dropdown"
            onClick={handleDropdown}
            onBlur={handleBlur}
            onChange={handleSelect}
            value={selectVal}
          >
            {selectData.map(({ name, value }) => (
              <option key={name} value={value}>
                {name}
              </option>
            ))}
          </select>
          <FontAwesomeIcon icon={'chevron-' + (dropdown ? 'up' : 'down')} />
        </div>
      </div>
    </div>
  );
};

TopicHeader.propTypes = {
  header: PropTypes.string.isRequired,
  searchVal: PropTypes.string.isRequired,
  selectVal: PropTypes.string.isRequired,
  selectData: PropTypes.array.isRequired,
  onSearch: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

TopicHeader.defaultProps = {
  selectData: [],
};

export default TopicHeader;
